import { render, staticRenderFns } from "./CompanyTobaAdditiveForm.vue?vue&type=template&id=60c3880e&"
import script from "./CompanyTobaAdditiveForm.vue?vue&type=script&lang=js&"
export * from "./CompanyTobaAdditiveForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports